import { runtimeWriter } from '../run/writers';
import { createContainersFromPath } from './createContainersFromPath';
import { defineClassLoader } from './defineClassLoader';
import { Multiname } from '../abc/lazy/Multiname';
export function makeClassLoader(applicationDomain, container, classPath, aliasPath, nsType) {
    runtimeWriter && runtimeWriter.writeLn('Defining Memoizer: ' + classPath);
    var aliasPathTokens = aliasPath.split('.');
    var aliasClassName = aliasPathTokens.pop();
    container = createContainersFromPath(aliasPathTokens, container);
    var mn = Multiname.FromFQNString(classPath, nsType);
    defineClassLoader(applicationDomain, container, mn, aliasClassName);
}
